import * as React from "react";
import { useNotify } from "react-admin";
import {
  Box, Card, CardContent, Typography, TextField, Button, Stack, Alert,
  CircularProgress,
} from "@mui/material";
import RecommendIcon from "@mui/icons-material/Recommend";
import { httpClient } from "../../api/httpClient";
import { API_BASE_URL } from "../../api/config";

const ReferralDashboard = () => {
  const [userId, setUserId] = React.useState("");
  const [data, setData] = React.useState(null);
  const [code, setCode] = React.useState("");
  const [validation, setValidation] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const notify = useNotify();

  const loadDash = async () => {
    if (!userId.trim()) return;
    setLoading(true);
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/referral/dashboard?userId=${encodeURIComponent(userId)}`
      );
      setData(json);
    } catch (e) {
      notify(`Erreur : ${e.message}`, { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const validate = async () => {
    if (!code.trim()) return;
    try {
      const { json } = await httpClient(
        `${API_BASE_URL}/referral/validate?code=${encodeURIComponent(code)}`
      );
      setValidation(json);
    } catch (e) {
      setValidation({ error: e.message });
    }
  };

  // Pas d'actions « inviter » / « réclamer » côté admin :
  //  - POST /referral/invite utilise toujours l'appelant comme parrain
  //    (impossible d'inviter au nom d'un utilisateur) ;
  //  - POST /referral/redeem exige un rewardCode et n'est pas encore
  //    implémenté côté service (réponse success=false systématique).

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <RecommendIcon /> Tableau de bord parrainage
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Consulter les parrainages d'un utilisateur (dashboard) et vérifier un code de parrainage.
      </Alert>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Stack spacing={2}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField size="small" label="ID utilisateur" value={userId}
                onChange={(e) => setUserId(e.target.value)} />
              <Button variant="contained" onClick={loadDash}
                disabled={loading || !userId.trim()}>
                {loading ? <CircularProgress size={18} /> : "Dashboard"}
              </Button>
            </Box>
            {data && (
              <Box component="pre" sx={{
                bgcolor: "#f5f7fa", p: 2, borderRadius: 1,
                fontSize: 12, maxHeight: 300, overflow: "auto",
              }}>
                {JSON.stringify(data, null, 2)}
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>Valider un code</Typography>
          <Stack direction="row" spacing={1}>
            <TextField size="small" label="Code parrainage" value={code}
              onChange={(e) => setCode(e.target.value)} />
            <Button variant="outlined" onClick={validate} disabled={!code.trim()}>
              Vérifier
            </Button>
          </Stack>
          {validation && (
            <Box component="pre" sx={{
              bgcolor: "#f5f7fa", p: 2, borderRadius: 1,
              fontSize: 12, mt: 2, maxHeight: 200, overflow: "auto",
            }}>
              {JSON.stringify(validation, null, 2)}
            </Box>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default { list: ReferralDashboard };
